/**
 * FromTheArchive — rediscovery module so important older files never get
 * buried. Under-viewed, evidence-heavy published dossiers rotated weekly.
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Archive } from "lucide-react";
import { resolveImg, relTime, SectionHeader } from "./homeShared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Card = ({ d }) => (
  <Link
    to={`/topic/${d.slug}`}
    data-testid={`from-archive-${d.slug}`}
    className="group flex gap-4 border p-3.5 hover:-translate-y-0.5 transition-transform duration-300"
    style={{ borderColor: "#2D2A26", background: "#0F0E12" }}
  >
    <div className="w-[88px] h-[88px] shrink-0 border overflow-hidden" style={{ borderColor: "#2D2A26", background: "#131015" }}>
      {d.image_url ? (
        <img
          src={resolveImg(d.thumb_url || d.image_url)}
          alt=""
          loading="lazy"
          className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
          style={{ filter: "saturate(0.7)" }}
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center text-[#454038]"><Archive size={22} /></div>
      )}
    </div>
    <div className="min-w-0 flex-1">
      <div className="font-mono text-[8px] uppercase tracking-[0.35em] text-[#8A8377]">
        {d.category} · Filed {relTime(d.created_at)}
      </div>
      <h3 className="mt-1 font-heading text-[15px] leading-snug text-[#E4DFD3] group-hover:text-[#D92D20] transition-colors line-clamp-2">
        {d.title}
      </h3>
      {d.brief && <p className="mt-1 text-[11.5px] leading-snug text-[#8A8377] line-clamp-2">{d.brief}</p>}
    </div>
  </Link>
);

const FromTheArchive = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    let dead = false;
    axios.get(`${API}/home/from-the-archive`, { timeout: 12000 })
      .then((r) => { if (!dead) setItems(r.data?.items || []); })
      .catch(() => {});
    return () => { dead = true; };
  }, []);

  if (!items.length) return null;
  return (
    <section data-testid="home-from-archive" className="border-t" style={{ borderColor: "#2D2A26", background: "#0B0A0D" }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10 md:py-20">
        <SectionHeader
          file="File 009 · Deep Storage"
          title="From the Archive"
          subtitle="Rediscover important files — rotated weekly so nothing stays buried."
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {items.map((d) => <Card key={d.slug} d={d} />)}
        </div>
      </div>
    </section>
  );
};

export default FromTheArchive;
